import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_generics__date_selector'

export const elements = object(null, {
  container: block,
  days: `${block}_days`,
  day: `${block}_day`,
  day_previous_month: `${block}_day_previous_month`,
  day_previous_year: `${block}_day_previous_year`,
  day_next_month: `${block}_day_next_month`,
  day_next_year: `${block}_day_next_year`,
  disabled: `${block}_disabled`,
  month: `${block}_month`,
  months: `${block}_months`,
  nav: `${block}_nav`,
  nav_button: `${block}_nav_button`,
  nav_date: `${block}_nav_date`,
  nav_months: `${block}_nav_months`,
  nav_years: `${block}_nav_years`,
  nav_years_range: `${block}_nav_years_range`,
  nav_text: `${block}_nav_text`,
  weekdays: `${block}_weekdays`,
  year: `${block}_year`,
  years: `${block}_years`,
})

export const modifiers = object(null, {
  nav_button: object(null, {
    disabled: `${elements.nav_button}-disabled`
  }),
  day: object(null, {
    today: `${elements.day}-today`
  }),
  month: object(null, {
    now: `${elements.month}-now`
  }),
  year: object(null, {
    now: `${elements.year}-now`
  }),
})
